'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.urlHelper = $.agito.urlHelper || {};

    $.agito.urlHelper.getParameterByName = function (url, name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    $.agito.urlHelper.updateQueryStringParameter = function (url, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = url.indexOf('?') !== -1 ? "&" : "?";
        if (url.match(re)) {
            return url.replace(re, '$1' + key + "=" + encodeURIComponent(value) + '$2');
        }
        else {
            return url + separator + key + "=" + encodeURIComponent(value);
        }
    };
})($);